function Footer() {
  const version = import.meta.env.VITE_VERSION || 'dev';
  const buildTimestamp = import.meta.env.VITE_BUILD_TIMESTAMP || 'local';

  return (
    <footer style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      padding: '8px 16px',
      backgroundColor: '#f5f5f5',
      borderTop: '1px solid #e0e0e0',
      fontSize: '12px',
      color: '#666',
      textAlign: 'center',
      zIndex: 1000,
    }}>
      Version: {version} | Built: {new Date(buildTimestamp).toLocaleString()}
    </footer>
  );
}

export default Footer;
